// @flow

import React from 'react';
import styled from 'styled-components';
import { RichText } from 'components/Text';

const Container = styled.div`
  .amp-img {
    position: relative;
    height: 300px;
    width: 100%;
  }
  .amp-img img {
    object-fit: cover;
  }
`;

const FreeCodeBlock = ({ data: { html } }: { data: { html: string } }) => {
  const sanitizedHtml = html
    .replace(/iframe/g, 'amp-iframe')
    .replace(
      /<img/g,
      '<amp-img width="1152" height="450" layout="fill" class="amp-img"'
    );
  return (
    <Container>
      {/* eslint-disable-next-line react/no-danger */}
      <RichText dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />
    </Container>
  );
};

export default FreeCodeBlock;
